import React, { Fragment, useState } from "react";
import ChannelsAndPacksComponent from "../../CommonUtils/SelectChannelsAndPacks/ChannelsAndPacks/ChannelsAndPacksComponent";
// Adjust path based on file structure
import ChevronIcon from "../../CommonUtils/ChevronIcon"
import "./MessageA13ExploreGenric.css";

export default function MessageA13ExploreGenric(props) {
    const { code, text } = props.item;
    const text_data = JSON.parse(text);

    const selectedLanguagesProps = text_data?.filter?.language?.selectedLanguages;
    const allLanguagesProps = text_data?.filter?.language?.listOfLanguages;
    const selectedGenresProps = text_data?.filter?.genre?.selectedGenre;
    const allGenresProps = text_data?.filter?.genre?.listOfGenre;
    const selectedHDSDProps = text_data?.filter?.hdOrSd;

    const [expandedGenres, setExpandedGenres] = useState({});

    const toggleGenre = (genreName) => {
        setExpandedGenres((prev) => ({
            ...prev,
            [genreName]: !prev[genreName],
        }));
    };

    const handleFilterApplied = () => { };
    const handleFilterClickHere = () => { };
    const onHandleSubmit = (code, data, tag) => {
        props.addMessages(data, code, null, null, null, "A59");
    };

    return (
        <Fragment>
            {Array.isArray(text_data) &&
                text_data.map((item, index) => {
                    const isExpanded = expandedGenres[item.genreName] || false;

                    return (
                        <div key={index} className="genre-section">
                            <div
                                className="genre-header"
                                onClick={() => toggleGenre(item.genreName)}
                            >
                                <span className="genre-name">{item.genreName}</span>
                                <ChevronIcon direction={isExpanded ? "up" : "down"} />
                            </div>

                            {/* {isExpanded && (
                <div style={{marginTop :'10px'}}>
                <ChannelsAndPacksComponent
                  {...props}
                  packsProps={Array.isArray(item?.packList) ? item?.packList : []}
                  filters={{
                    language: "",
                    genre: "",
                    hdOrSd: selectedHDSDProps,
                  }}
                  prioratizePacks={
                    Array.isArray(item?.packList?.fullyMatchedPacks)
                      ? item?.packList.fullyMatchedPacks
                      : []
                  }
                  selectedHd={
                    typeof item?.packList?.filter?.hdOrSd === "string"
                      ? item?.packList.filter.hdOrSd
                      : ""
                  }
                  selectedLanguagesProps={selectedLanguagesProps}
                  allLanguagesProps={allLanguagesProps}
                  selectedGenresProps={selectedGenresProps}
                  allGenresProps={allGenresProps}
                  onClickFilter={handleFilterClickHere}
                  onClickSubmit={onHandleSubmit}
                  filterTag="A58"
                  filterToggle={handleFilterApplied}
                  tag={props.tag}
                  code={code}
                  preSelectedChannels={
                    item?.packList?.selectedChannels?.channelList || []
                  }
                  preSelectedPacks={
                    item?.packList?.selectedPacks?.packList || []
                  }
                  explorePacks={true}
                  showMaximumChat={props.showMaximumChat}
                />
                </div>
                             )} */}
                            <div className={`channels-wrapper ${isExpanded ? "expanded" : ""}`}>
                                <div className="channels-inner">
                                    {isExpanded && (
                                        <ChannelsAndPacksComponent
                                            {...props}
                                            packsProps={Array.isArray(item?.packList) ? item?.packList : []}
                                            filters={{
                                                language: "",
                                                genre: "",
                                                hdOrSd: selectedHDSDProps,
                                            }}
                                            prioratizePacks={
                                                Array.isArray(item?.packList?.fullyMatchedPacks)
                                                    ? item?.packList.fullyMatchedPacks
                                                    : []
                                            }
                                            selectedHd={
                                                typeof item?.packList?.filter?.hdOrSd === "string"
                                                    ? item?.packList.filter.hdOrSd
                                                    : ""
                                            }
                                            selectedLanguagesProps={selectedLanguagesProps}
                                            allLanguagesProps={allLanguagesProps}
                                            selectedGenresProps={selectedGenresProps}
                                            allGenresProps={allGenresProps}
                                            onClickFilter={handleFilterClickHere}
                                            onClickSubmit={onHandleSubmit}
                                            filterTag="A58"
                                            filterToggle={handleFilterApplied}
                                            tag={props.tag}
                                            code={code}
                                            preSelectedChannels={
                                                item?.packList?.selectedChannels?.channelList || []
                                            }
                                            preSelectedPacks={
                                                item?.packList?.selectedPacks?.packList || []
                                            }
                                            explorePacks={true}
                                            showMaximumChat={props.showMaximumChat}
                                        />
                                    )}
                                </div>
                            </div>

                        </div>
                    );
                })}
        </Fragment>
    );
}
